import repository from '@/repositories/repository'

export default baseUrl => {
    baseUrl = `${baseUrl}/acolhimento-saude-bucal`

    return {
        create(filaId) {
            return repository.get(`${baseUrl}/create/${filaId}`)
        },
        store(filaId, params) {
            return repository.post(`${baseUrl}/${filaId}/store`, params)
        },
    }
}
